import React, { type HTMLAttributes } from "react";
import c from "classnames/bind";

import styles from "./color-dot.module.scss";

const cx = c.bind(styles);
const rootClassName = "purpur-color-dot";

export const STATIC_COLOR_DOT_SIZE = ["xs", "sm", "md", "lg"] as const;
export const BUTTON_COLOR_DOT_SIZE = STATIC_COLOR_DOT_SIZE.filter((size) => size !== "xs");

export type StaticColorDotSize = (typeof STATIC_COLOR_DOT_SIZE)[number];
export type ButtonColorDotSize = (typeof BUTTON_COLOR_DOT_SIZE)[number];
export type StaticColorDotProps = HTMLAttributes<HTMLDivElement> & {
  variant?: "static";
  isSelected?: never;
  size: StaticColorDotSize;
};

export type ButtonColorDotProps = HTMLAttributes<HTMLButtonElement> & {
  variant?: "button";
  isSelected?: boolean;
  size: ButtonColorDotSize;
};

export type ColorDotProps = {
  color: string;
  withBorder?: boolean;
} & (StaticColorDotProps | ButtonColorDotProps);

export const ColorDot = ({ size, withBorder, variant = "static", ...props }: ColorDotProps) => {
  const className = cx(props.className, rootClassName, `${rootClassName}--${size}`, {
    [`${rootClassName}--with-border`]: withBorder,
    [`${rootClassName}--selected`]: props.isSelected,
    [`${rootClassName}--button`]: variant === "button",
  });

  props.className = className;
  props.style = {
    ...props.style,
    backgroundColor: props.color,
  };

  if (variant === "button") {
    return <button {...(props as ButtonColorDotProps)} />;
  }
  return <div {...(props as StaticColorDotProps)} />;
};
